/**
 * Folds free-text search input and haystacks onto one comparable form:
 * lowercase, alphanumerics and spaces only, single-space separated.
 * Applied to BOTH sides of every match so "levis" finds "Levi's"
 * (HLD CAT-01 search semantics).
 */
export function normalizeSearchText(value: string): string {
  return value
    .toLowerCase()
    .replace(/[^a-z0-9\s]+/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}
